module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pagina-erro', {
    attrs: {
      "titulo": "Informação importante",
      "icone": "fa fa-calendar-times-o",
      "imagemTexto": "centralservidor-logo-texto.png",
      "imagem": "centralservidor-logo.png",
      "texto": "Sua secretaria não participará,\n    neste ano, do cadastramento através da Central do Servidor. Informe-se\n    com seu superior direto."
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2379d1b9","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/uor-nao-participante/index.vue
// module id = 26OG
// module chunks = 5